import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { render } from "react-dom";

import './index.scss';

import reportWebVitals from './reportWebVitals';

import HomePage from "./home/index";
import OurteamPage from "./team/team";
import AboutUsPage from "./aboutus/aboutus";
import OurInsuranceSolutions from "./ourinsurancesolutions/ourinsurancesolutions";

import TravelInsurance from "./personalinsurance/travelinsurance/travelinsurance";
import LifeInsurance from "./personalinsurance/lifeinsurance/lifeinsurance";
import PersonalAccident from "./personalinsurance/personalaccident/personalaccident";
import RelocationInsurance from "./personalinsurance/relocationinsurance/relocationinsurance";
import HealthInsurance from "./personalinsurance/healthinsurance/healthinsurance";
import ArtInsurance from "./personalinsurance/artinsurance/artinsurance";
import GolfInsurance from "./personalinsurance/golfinsurance/golfinsurance";
import MotorInsurance from "./personalinsurance/motorinsurance/motorinsurance";
import HousemaidInsurance from "./personalinsurance/housemaidinsurance/housemaidinsurance";
import HomeInsurance from "./personalinsurance/homeinsurance/homeinsurance";
import YachtInsurance from "./personalinsurance/yachtinsurance/yachtinsurance";

import GroupPersonalAccidentInsurance from "./businessinsurance/grouppersonalaccidentinsurance/grouppersonalaccidentinsurance";
import PropertyInsurance from "./businessinsurance/propertyinsurance/propertyinsurance";
import TerrorismandPoliticalRiskInsurance from "./businessinsurance/terrorismandpoliticalriskinsurance/terrorismandpoliticalriskinsurance";
import GroupHealthInsurance from "./businessinsurance/grouphealthinsurance/grouphealthinsurance";
import GroupLifeInsurance from "./businessinsurance/grouplifeinsurance/grouplifeinsurance";
import FidelityGuaranteeInsurance from "./businessinsurance/fidelityguaranteeinsurance/fidelityguaranteeinsurance";
import CyberCrimeInsurance from "./businessinsurance/cybercrimeinsurance/cybercrimeinsurance";
import BurglaryInsurance from "./businessinsurance/burglaryinsurance/burglaryinsurance";
import ProjectInsurance from "./businessinsurance/projectinsurance/projectinsurance";
import JewellersBlockInsurance from "./businessinsurance/jewellersblockinsurance/jewellersblockinsurance";
import StockThroughputInsurance from "./businessinsurance/stockthroughputinsurance/stockthroughputinsurance";
import WorkmenCompensationInsurance from "./businessinsurance/workmencompensationinsurance/workmencompensationinsurance";
import HauliersFullValueCargoInsurance from "./businessinsurance/hauliersfullvaluecargoinsurance/hauliersfullvaluecargoinsurance";
import SpecialityRiskEventInsurance from "./businessinsurance/specialityriskeventinsurance/specialityriskeventinsurance";
import LiabilityInsurance from "./businessinsurance/liabilityinsurance/liabilityinsurance";
import MotorFleetInsurance from "./businessinsurance/motorfleetinsurance/motorfleetinsurance";
import MarineInsurance from "./businessinsurance/marineinsurance/marineinsurance";
import EnergyInsurance from "./businessinsurance/energyinsurance/energyinsurance";

import RiskInspectionServices from "./valuedservices/riskinspectionservices/riskinspectionservices";
import ThermographyTestingInsurance from "./valuedservices/thermographytestinginsurance/thermographytestinginsurance";
import ValuationServices from "./valuedservices/valuationservices/valuationservices";
import InsuranceAudits from "./valuedservices/insuranceaudits/insuranceaudits";
import EmployeeWellnessProgram from "./valuedservices/employeewellnessprogram/employeewellnessprogram";
import PolicyRenewalAlerts from "./valuedservices/policyrenewalalerts/policyrenewalalerts";

import ReportaClaim from "./customerservice/reportaclaim/reportaclaim";
import ServiceExcellence from "./customerservice/serviceexcellence/serviceexcellence";
import InhouseKRAutomotiveGarage from "./customerservice/inhousekrautomotivegarage/inhousekrautomotivegarage";
import ClaimConsultancyServices from "./customerservice/claimconsultancyservices/claimconsultancyservices";
import ErpBasedSolutions from "./customerservice/erpbasedsolutions/erpbasedsolutions";


import ContactUsPage from "./contactus/contactus";
import PrivacyPolicy from "./privacypolicy/privacypolicy";
import CookiePolicy from "./cookiepolicy/cookiepolicy";

import ARHomePage from "./arhome/index";
import ARAboutUsPage from "./araboutus/araboutus";
import AROurInsuranceSolutions from "./arourinsurancesolutions/arourinsurancesolutions";
import ARContactUsPage from "./arcontactus/arcontactus";
import ARPrivacyPolicy from "./arprivacypolicy/arprivacypolicy";
import AROurteamPage from "./arteam/arteam";

import ARPropertyInsurance from "./businessinsurance/arpropertyinsurance/arpropertyinsurance";
import ARProjectInsurance from "./businessinsurance/arprojectinsurance/arprojectinsurance";
import ARTerrorismandPoliticalRiskInsurance from "./businessinsurance/arterrorismandpoliticalriskinsurance/arterrorismandpoliticalriskinsurance";
import ARMotorFleetInsurance from "./businessinsurance/armotorfleetinsurance/armotorfleetinsurance";
import ARGroupHealthInsurance from "./businessinsurance/argrouphealthinsurance/argrouphealthinsurance";
import ARGroupLifeInsurance from "./businessinsurance/argrouplifeinsurance/argrouplifeinsurance";
import ARFidelityGuaranteeInsurance from "./businessinsurance/arfidelityguaranteeinsurance/arfidelityguaranteeinsurance";
import ARBurglaryInsurance from "./businessinsurance/arburglaryinsurance/arburglaryinsurance";
import ARWorkmenCompensationInsurance from "./businessinsurance/arworkmencompensationinsurance/arworkmencompensationinsurance";
import ARGroupPersonalAccidentInsurance from "./businessinsurance/argrouppersonalaccidentinsurance/argrouppersonalaccidentinsurance";
import ARCyberCrimeInsurance from "./businessinsurance/arcybercrimeinsurance/arcybercrimeinsurance";
import ARJewellersBlockInsurance from "./businessinsurance/arjewellersblockinsurance/arjewellersblockinsurance";
import ARStockThroughputInsurance from "./businessinsurance/arstockthroughputinsurance/arstockthroughputinsurance";
import ARHauliersFullValueCargoInsurance from "./businessinsurance/arhauliersfullvaluecargoinsurance/arhauliersfullvaluecargoinsurance";
import ARSpecialityRiskEventInsurance from "./businessinsurance/arspecialityriskeventinsurance/arspecialityriskeventinsurance";
import ARLiabilityInsurance from "./businessinsurance/arliabilityinsurance/arliabilityinsurance";
import ARMarineInsurance from "./businessinsurance/armarineinsurance/armarineinsurance";
import AREnergyInsurance from "./businessinsurance/arenergyinsurance/arenergyinsurance";

import ARMotorInsurance from "./personalinsurance/armotorinsurance/armotorinsurance";
import ARTravelInsurance from "./personalinsurance/artravelinsurance/artravelinsurance";
import ARPersonalAccident from "./personalinsurance/arpersonalaccident/arpersonalaccident";
import ARRelocationInsurance from "./personalinsurance/arrelocationinsurance/arrelocationinsurance";
import ARHealthInsurance from "./personalinsurance/arhealthinsurance/arhealthinsurance";
import ARArtInsurance from "./personalinsurance/arartinsurance/arartinsurance";
import ARGolfInsurance from "./personalinsurance/argolfinsurance/argolfinsurance";
import ARHousemaidInsurance from "./personalinsurance/arhousemaidinsurance/arhousemaidinsurance";
import ARYachtInsurance from "./personalinsurance/aryachtinsurance/aryachtinsurance";
import ARHomeInsurance from "./personalinsurance/arhomeinsurance/arhomeinsurance";
import ARLifeInsurance from "./personalinsurance/arlifeinsurance/arlifeinsurance";

import ARRiskInspectionServices from "./valuedservices/arriskinspectionservices/arriskinspectionservices";
import ARInsuranceAudits from "./valuedservices/arinsuranceaudits/arinsuranceaudits";
import ARValuationServices from "./valuedservices/arvaluationservices/arvaluationservices";
import ARThermographyTestingInsurance from "./valuedservices/arthermographytestinginsurance/arthermographytestinginsurance";
import AREmployeeWellnessProgram from "./valuedservices/aremployeewellnessprogram/aremployeewellnessprogram";

import ARReportaClaim from "./customerservice/arreportaclaim/arreportaclaim";
import ARClaimConsultancyServices from "./customerservice/arclaimconsultancyservices/arclaimconsultancyservices";
import ARServiceExcellence from "./customerservice/arserviceexcellence/arserviceexcellence";
import ARInhouseKRAutomotiveGarage from "./customerservice/arinhousekrautomotivegarage/arinhousekrautomotivegarage";
import ARErpBasedSolutions from "./customerservice/arerpbasedsolutions/arerpbasedsolutions";


//import ARTeam from "./arteam/arteam";
//import ARContactUsPage from "./arcontactus/arcontactus";
//import ARPersonalInsurance from "./arpersonalinsurance/arpersonalinsurance";

import PageNotFound from './PageNotFound';
// import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import CookieBanner from "./components/CookieBanner";

const root = document.getElementById("root");
render(<React.StrictMode>
  <Router>
    <CookieBanner />
    <div className="App">
      <div className="content">
        <Switch>
          <Route exact path="/">
            <HomePage />
          </Route>
          <Route exact path="/omanbr">
            <HomePage />
          </Route>
          <Route exact path="/aboutus">
            <AboutUsPage />
          </Route>
          <Route exact path="/our-insurance-solutions">
            <OurInsuranceSolutions />
          </Route>
          <Route exact path="/team">
            <OurteamPage />
          </Route>
          <Route exact path="/contactus">
            <ContactUsPage />
          </Route>
          <Route exact path="/travel-insurance">
            <TravelInsurance />
          </Route>
          <Route exact path="/life-insurance">
            <LifeInsurance />
          </Route>
          <Route exact path="/personal-accident">
            <PersonalAccident />
          </Route>
          <Route exact path="/relocation-insurance">
            <RelocationInsurance />
          </Route>
          <Route exact path="/health-insurance">
            <HealthInsurance />
          </Route>
          <Route exact path="/art-insurance">
            <ArtInsurance />
          </Route>
          <Route exact path="/golf-insurance">
            <GolfInsurance />
          </Route>
          <Route exact path="/motor-insurance">
            <MotorInsurance />
          </Route>
          <Route exact path="/housemaid-insurance">
            <HousemaidInsurance />
          </Route>
          <Route exact path="/home-insurance">
            <HomeInsurance />
          </Route>
          <Route exact path="/yacht-insurance">
            <YachtInsurance />
          </Route>
          
          <Route exact path="/group-personal-accident-insurance">
            <GroupPersonalAccidentInsurance />
          </Route>
          <Route exact path="/property-insurance">
            <PropertyInsurance />
          </Route>
          <Route exact path="/terrorism-and-political-risk-insurance">
            <TerrorismandPoliticalRiskInsurance />
          </Route>
          <Route exact path="/group-health-insurance">
            <GroupHealthInsurance />
          </Route>
          <Route exact path="/group-life-insurance">
            <GroupLifeInsurance />
          </Route>
          <Route exact path="/fidelity-guarantee-insurance">
            <FidelityGuaranteeInsurance />
          </Route>
          <Route exact path="/cyber-crime-insurance">
            <CyberCrimeInsurance />
          </Route>
          <Route exact path="/burglary-insurance">
            <BurglaryInsurance />
          </Route>
          <Route exact path="/project-insurance">
            <ProjectInsurance />
          </Route>
          <Route exact path="/jewellers-block-insurance">
            <JewellersBlockInsurance />
          </Route>
          <Route exact path="/stock-throughput-insurance">
            <StockThroughputInsurance />
          </Route>
          <Route exact path="/workmen-compensation-insurance">
            <WorkmenCompensationInsurance />
          </Route>
          <Route exact path="/hauliers-full-value-cargo-insurance">
            <HauliersFullValueCargoInsurance />
          </Route>
          <Route exact path="/speciality-risk-event-insurance">
            <SpecialityRiskEventInsurance />
          </Route>
          <Route exact path="/liability-insurance">
            <LiabilityInsurance />
          </Route>
          <Route exact path="/motor-fleet-insurance">
            <MotorFleetInsurance />
          </Route>
          <Route exact path="/marine-insurance">
            <MarineInsurance />
          </Route>
          <Route exact path="/energy-insurance">
            <EnergyInsurance />
          </Route>
          

          <Route exact path="/risk-inspection-services">
            <RiskInspectionServices />
          </Route>
          <Route exact path="/thermography-testing-insurance">
            <ThermographyTestingInsurance />
          </Route>
          <Route exact path="/valuation-services">
            <ValuationServices />
          </Route>
          <Route exact path="/insurance-audits">
            <InsuranceAudits />
          </Route>
          <Route exact path="/employee-wellness-program">
            <EmployeeWellnessProgram />
          </Route>
          
          <Route exact path="/policy-renewalalerts">
            <PolicyRenewalAlerts />
          </Route>

          <Route exact path="/report-a-claim">
            <ReportaClaim />
          </Route>
          <Route exact path="/service-excellence">
            <ServiceExcellence />
          </Route>
          <Route exact path="/in-house-kr-automotive-garage">
            <InhouseKRAutomotiveGarage />
          </Route>
          <Route exact path="/claim-consultancy-services">
            <ClaimConsultancyServices />
          </Route>
          <Route exact path="/erp-based-solutions">
            <ErpBasedSolutions />
          </Route>
          
          <Route exact path="/privacy-policy">
            <PrivacyPolicy />
          </Route>
          <Route exact path="/cookie-policy">
            <CookiePolicy />
          </Route>




          {/* ARBIC PAGES URLs*/}
          <Route exact path="/-ar">
            <ARHomePage />
          </Route>
          <Route exact path="/omanbr-ar">
            <ARHomePage />
          </Route>
          <Route exact path="/aboutus-ar">
            <ARAboutUsPage />
          </Route>
          <Route exact path="/contactus-ar">
            <ARContactUsPage />
          </Route>
          <Route exact path="/our-insurance-solutions-ar">
            <AROurInsuranceSolutions />
          </Route>
          <Route exact path="/privacy-policy-ar">
            <ARPrivacyPolicy />
          </Route>
          <Route exact path="/team-ar">
            <AROurteamPage />
          </Route>

          <Route exact path="/property-insurance-ar">
            <ARPropertyInsurance />
          </Route>
          <Route exact path="/project-insurance-ar">
            <ARProjectInsurance />
          </Route>
          <Route exact path="/terrorism-and-political-risk-insurance-ar">
            <ARTerrorismandPoliticalRiskInsurance />
          </Route>
          <Route exact path="/motor-fleet-insurance-ar">
            <ARMotorFleetInsurance />
          </Route>
          <Route exact path="/group-health-insurance-ar">
            <ARGroupHealthInsurance />
          </Route>
          <Route exact path="/group-life-insurance-ar">
            <ARGroupLifeInsurance />
          </Route>
          <Route exact path="/fidelity-guarantee-insurance-ar">
            <ARFidelityGuaranteeInsurance />
          </Route>
          <Route exact path="/burglary-insurance-ar">
            <ARBurglaryInsurance />
          </Route>
          <Route exact path="/workmen-compensation-insurance-ar">
            <ARWorkmenCompensationInsurance />
          </Route>
          <Route exact path="/group-personal-accident-insurance-ar">
            <ARGroupPersonalAccidentInsurance />
          </Route>
          <Route exact path="/cyber-crime-insurance-ar">
            <ARCyberCrimeInsurance />
          </Route>
          <Route exact path="/jewellers-block-insurance-ar">
            <ARJewellersBlockInsurance />
          </Route>
          <Route exact path="/stock-throughput-insurance-ar">
            <ARStockThroughputInsurance />
          </Route>
          <Route exact path="/hauliers-full-value-cargo-insurance-ar">
            <ARHauliersFullValueCargoInsurance />
          </Route>
          <Route exact path="/speciality-risk-event-insurance-ar">
            <ARSpecialityRiskEventInsurance />
          </Route>
          <Route exact path="/liability-insurance-ar">
            <ARLiabilityInsurance />
          </Route>
          <Route exact path="/marine-insurance-ar">
            <ARMarineInsurance />
          </Route>
          <Route exact path="/energy-insurance-ar">
            <AREnergyInsurance />
          </Route>
          <Route exact path="/motor-insurance-ar">
            <ARMotorInsurance />
          </Route>
          <Route exact path="/travel-insurance-ar">
            <ARTravelInsurance />
          </Route>
          <Route exact path="/personal-accident-ar">
            <ARPersonalAccident />
          </Route>
          <Route exact path="/relocation-insurance-ar">
            <ARRelocationInsurance />
          </Route>
          <Route exact path="/health-insurance-ar">
            <ARHealthInsurance />
          </Route>
          <Route exact path="/art-insurance-ar">
            <ARArtInsurance />
          </Route>
          <Route exact path="/golf-insurance-ar">
            <ARGolfInsurance />
          </Route>
          <Route exact path="/housemaid-insurance-ar">
            <ARHousemaidInsurance />
          </Route>
          <Route exact path="/yacht-insurance-ar">
            <ARYachtInsurance />
          </Route>
          <Route exact path="/home-insurance-ar">
            <ARHomeInsurance />
          </Route>
          <Route exact path="/life-insurance-ar">
            <ARLifeInsurance />
          </Route>

          {/* Valued Services */}
          <Route exact path="/risk-inspection-services-ar">
            <ARRiskInspectionServices />
          </Route>
          <Route exact path="/insurance-audits-ar">
            <ARInsuranceAudits />
          </Route>
          <Route exact path="/valuation-services-ar">
            <ARValuationServices />
          </Route>
          <Route exact path="/thermography-testing-insurance-ar">
            <ARThermographyTestingInsurance />
          </Route>
          <Route exact path="/employee-wellness-program-ar">
            <AREmployeeWellnessProgram />
          </Route>

          {/* Customer Services */}
          <Route exact path="/report-a-claim-ar">
            <ARReportaClaim />
          </Route>
          <Route exact path="/claim-consultancy-services-ar">
            <ARClaimConsultancyServices />
          </Route>
          <Route exact path="/service-excellence-ar">
            <ARServiceExcellence />
          </Route>
          <Route exact path="/in-house-kr-automotive-garage-ar">
            <ARInhouseKRAutomotiveGarage />
          </Route>
          <Route exact path="/erp-based-solutions-ar">
            <ARErpBasedSolutions />
          </Route>

          
          <Route exact path="*">
            <PageNotFound />
          </Route>
        </Switch>
      </div>
    </div>
  </Router>
  {/* <App /> */}

</React.StrictMode>, root);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
